export const checkIsFieldRequired = (fieldName, requiredFields) =>
  requiredFields.hasOwnProperty(fieldName) ? requiredFields[fieldName] : true;
